import React from 'react';
import styles from './AboutUs.module.css';
import teamImage from '../assets/team_collaboration.jpg'; // Example professional team image
import usePageTracking from '../components/UsePageTracking';

function AboutUs() {

  usePageTracking();

  return (
    <div className={styles.aboutUsPage}>
      <section className={styles.heroAbout}>
        <h1>Our Vision: Empowering Data-Driven Leadership.</h1>
        <p>At Talk2Board AI, we are driven by a singular mission: to transform complex data into clear, actionable strategies that empower organizations to achieve their full potential.</p>
      </section>

      <section className={styles.ourStory}>
        <div className={styles.storyContent}>
          <h2>Our Story</h2>
          <p>Talk2Board AI was founded by a team of seasoned professionals, each bringing over 15 years of deep expertise in software and data engineering. Our collective journey spans across critical sectors including <b><i>financial investment technology, insurance, and healthcare,</i> </b> where we've consistently delivered impactful product development, robust APIs, and sophisticated data and analytics applications.</p>
          <p>What truly drives us is a profound <b> passion for solving the complex challenges of the AI era.</b> We believe that the transformative potential of artificial intelligence, particularly for the agentic workflows of tomorrow, must be <b> grounded in solid software and engineering practices, built upon fundamental basics and first principles.</b> This commitment ensures that the AI solutions we develop for you are not just innovative, but also reliable, scalable, and ethically sound, empowering your business for sustained success in an intelligent future.</p>
        </div>
        <div className={styles.storyImage}>
          <img src={teamImage} alt="Talk2Board Analytics Team Collaboration" />
        </div>
      </section>

      <section className={styles.ourPhilosophy}>
        <h2>Our Philosophy</h2>
        <div className={styles.philosophyGrid}>
          <div className={styles.philosophyItem}>
            <h3>Uncompromising Excellence</h3>
            <p>We commit to the highest standards of analytical rigor, innovative thinking, and ethical practice in every engagement.</p>
          </div>
          <div className={styles.philosophyItem}>
            <h3>True Partnership</h3>
            <p>We work as an extension of your team, fostering collaborative relationships built on trust, transparency, and shared goals.</p>
          </div>
          <div className={styles.philosophyItem}>
            <h3>Future-Forward</h3>
            <p>We equip your organization with the capabilities and foresight needed to adapt, innovate, and thrive in tomorrow's landscape.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;